{
  "TRANSFER_TO_AGENT": {
    "TOOLTIP": "Прехвърляне към оператор",
    "MESSAGE": "Свържете ме с оператор"
  },
  "COMPONENTS": {
    "FILE_BUBBLE": {
      "DOWNLOAD": "Изтегляне",
      "UPLOADING": "Качване..."
    },
    "FORM_BUBBLE": {
      "SUBMIT": "Изпращане"
    },
    "MESSAGE_BUBBLE": {
      "RETRY": "Изпрати отново",
      "ERROR_MESSAGE": "Съобщението не беше изпратено, опитайте отново"
    },
    "MESSAGE_RATING": {
      "TOOLTIP": "Оценете качеството на този отговор"
    }
  },
  "WAITING_FOR_AGENT": {
    "MESSAGE": "Моля, изчакайте да се присъедини агент"
  },
  "ROBOT_CHECK": {
    "TITLE": "Бърза проверка за сигурност",
    "DESCRIPTION": "Моля, преминете през проверката по-долу.",
    "VERIFYING": "Проверка…",
    "ERROR": "Това не сработи. Моля, опитайте отново.",
    "RETRY": "Опитайте отново"
  },
  "TEAM_AVAILABILITY": {
    "ONLINE": "На линия сме",
    "OFFLINE": "В момента не сме на линия",
    "ONLINE_WITH_BOT": "Екипът и нашият AI асистент са на линия",
    "OFFLINE_WITH_BOT": "Нашите AI асистенти са тук, за да помогнат",
    "BOT_ONLY_REPLY": "Отговаря незабавно"
  },
  "REPLY_TIME": {
    "IN_A_FEW_MINUTES": "Обикновено отговаряме до няколко минути",
    "IN_A_FEW_HOURS": "Обикновено отговаряме до няколко часа",
    "IN_A_DAY": "Обикновено отговаряме до един ден",
    "BACK_IN": "Ще бъдем отново на линия"
  },
  "DAY_NAMES": {
    "SUNDAY": "Неделя",
    "MONDAY": "Понеделник",
    "TUESDAY": "Вторник",
    "WEDNESDAY": "Сряда",
    "THURSDAY": "Четвъртък",
    "FRIDAY": "Петък",
    "SATURDAY": "Събота"
  },
  "START_CONVERSATION": "Започнете разговор",
  "END_CONVERSATION": "Приключете разговора",
  "CONTINUE_CONVERSATION": "Продължете разговора",
  "YOU": "Вие",
  "START_NEW_CONVERSATION": "Започнете нов разговор",
  "RESOLVE_LATER": "Ще решим тази тема по имейл/телефон. Сега искам да попитам за нещо друго.",
  "VIEW_UNREAD_MESSAGES": "Имате непрочетени съобщения",
  "UNREAD_VIEW": {
    "VIEW_MESSAGES_BUTTON": "Вижте новите съобщения",
    "CLOSE_MESSAGES_BUTTON": "Затвори",
    "COMPANY_FROM": "от",
    "BOT": "Бот"
  },
  "BUBBLE": {
    "LABEL": "Чатете с нас"
  },
  "POWERED_BY": "Осъществено от {brandName}",
  "EMAIL_PLACEHOLDER": "Моля, въведете имейла адреса си",
  "CHAT_PLACEHOLDER": "Напишете вашето съобщение",
  "TODAY": "Днес",
  "YESTERDAY": "Вчера",
  "PRE_CHAT_FORM": {
    "FIELDS": {
      "FULL_NAME": {
        "LABEL": "Пълно име",
        "PLACEHOLDER": "Моля, въведете пълното си име",
        "REQUIRED_ERROR": "Пълното име е задължително"
      },
      "EMAIL_ADDRESS": {
        "LABEL": "Имейл адрес",
        "PLACEHOLDER": "Моля, въведете имейл адреса си",
        "REQUIRED_ERROR": "Имейл адресът е задължителен",
        "VALID_ERROR": "Моля, въведете валиден имейл адрес"
      },
      "PHONE_NUMBER": {
        "LABEL": "Телефон",
        "PLACEHOLDER": "Моля, въведете телефонния си номер",
        "REQUIRED_ERROR": "Телефонният номер е задължителен",
        "DIAL_CODE_VALID_ERROR": "Моля, изберете код на държава",
        "VALID_ERROR": "Моля, въведете валиден телефонен номер",
        "DROPDOWN_EMPTY": "Няма намерени резултати",
        "DROPDOWN_SEARCH": "Търсене на държава"
      },
      "MESSAGE": {
        "LABEL": "Съобщение",
        "PLACEHOLDER": "Моля, въведете вашето съобщение",
        "ERROR": "Съобщението е прекалено кратко"
      }
    },
    "CAMPAIGN_HEADER": "Преди да започенте разговора, моля, посочете вашето име и имейл адрес",
    "IS_REQUIRED": "е задължително",
    "REQUIRED": "Задължително",
    "REGEX_ERROR": "Моля, въведете валидна стойност"
  },
  "FILE_SIZE_LIMIT": "Файлът надхвърля {MAXIMUM_FILE_UPLOAD_SIZE} лимит",
  "CHAT_FORM": {
    "INVALID": {
      "FIELD": "Невалидно поле"
    }
  },
  "EMOJI": {
    "PLACEHOLDER": "Търсене на емоджи",
    "NOT_FOUND": "Няма намерени емоджита, отговарящи на търсенето",
    "ARIA_LABEL": "Избор на емоджи"
  },
  "CSAT": {
    "TITLE": "Оценете този разговор",
    "SUBMITTED_TITLE": "Благодарим ви, че оценихте разговора",
    "PLACEHOLDER": "Разкажете ни повече..."
  },
  "EMAIL_TRANSCRIPT": {
    "BUTTON_TEXT": "Поискайте копие от разговора",
    "SEND_EMAIL_SUCCESS": "Копието от разговора бе изпратено успешно",
    "SEND_EMAIL_ERROR": "Възникна грешка, моля опитайте отново"
  },
  "PORTAL": {
    "POPULAR_ARTICLES": "Популярни статии",
    "VIEW_ALL_ARTICLES": "Вижте всички статии",
    "IFRAME_LOAD_ERROR": "Възникна грешка при зареждането на статията. Моля, презаредете страницата и опитайте отново."
  },
  "CARDS": {
    "ACTIONS": {
      "OPEN": "Отвори",
      "BUY": "Купи"
    }
  },
  "ATTACHMENTS": {
    "image": {
      "CONTENT": "Съобщение със снимка"
    },
    "audio": {
      "CONTENT": "Аудио съобщение"
    },
    "video": {
      "CONTENT": "Видео съобщение"
    },
    "file": {
      "CONTENT": "Прикачен файл"
    },
    "location": {
      "CONTENT": "Локация"
    },
    "fallback": {
      "CONTENT": "сподели линк"
    }
  },
  "FOOTER_REPLY_TO": {
    "REPLY_TO": "Отговор на:"
  }
}
